import script from "./ColorGradientBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorGradientBarChart.vue?vue&type=script&setup=true&lang=js"

import "./ColorGradientBarChart.vue?vue&type=style&index=0&id=e0166dc2&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0166dc2"]])

export default __exports__